/* eslint-disable */
const LangErrorMessage = {
  "_shared.form.validate._emailIsNotValid": [
    "Please enter a valid email address",
    "Địa chỉ email không hợp lệ"
  ],
  "_shared.form.validate._passwordIsNotValid": [
    "Password needs to be minimum 8 alphanumeric characters",
    "Mật khẩu không hợp lệ"
  ],
  "_shared.form._required": ["* Required", "* Vui lòng nhập"],
  "_shared.form.validate._required": [
    "${ label } is required",
    "Vui lòng nhập ${ label }"
  ],
  "_shared.form.validate._minLength": [
    "Must be ${minLength} numeric characters",
    "Phải dài ít nhất ${minLength} ký tự"
  ],
  "_shared.form.validate._notReCaptcha": [
    "Please check recaptcha box",
    "Vui lòng chọn recaptcha"
  ],
  "_shared.form.validate._mobileMinLength": [
    "Must be 8 numeric characters",
    "Phải dài ít nhất 8 ký tự"
  ],
  "_shared.form.validate._passwordminLength": ["Invalid password format"],
  "_shared.form.validate._passwordmaxLength": [
    "Password needs to be minium 8 alphanumeric characters"
  ],
  "_shared.form.validate._fixedLength": [
    "Must be ${fixedLength} characters",
    "Phải dài ${fixedLength} ký tự"
  ],
  "_shared.form.validate._maxLength": [
    "Must be no more than ${maxLength} characters",
    "Không được nhiều hơn $ {maxLength} ký tự"
  ],
  "_shared.form.validate._integer": [
    "Please fill in number",
    "Vui lòng nhập số"
  ],
  "_shared.form.validate._notMatch": [
    "Do not match ${match}",
    "${match} không khớp"
  ],
  "_shared.form.validate._invalidDate": [
    "The birthday is invalid",
    "Ngày sinh nhật không hợp lệ"
  ],
  "_shared.form.validate._allowFileExtensions": [
    "Please upload FileFormats: *.jpeg, *.jpg, *.gif, *png, *pdf",
    "Vui lòng tải lên các file *.jpeg, *.jpg, *.gif, *png, *pdf"
  ],

  "_shared.form.validate._moreThanMaxFileSize": [
    "Must be not more than ${maxSize} Mb",
    "Dung lượng không quá ${maxSize} Mb"
  ],
  "_shared.form.validate._noSpecialChars": [
    "Please don't use any special characters.",
    "Vui lòng không gõ Tiếng Việt."
  ],
  "_shared.form.validate._noVnChars": [
    "Only enter alphabets with no Vietnamese marks.",
    "Vui lòng nhập thông tin không dấu."
  ],
  "_shared.page.params._invalidCardNo": [
    "Invalid Card No!",
    "Số thẻ không hợp lệ"
  ]
};

export default LangErrorMessage;



// WEBPACK FOOTER //
// ./src/resources/general/LangErrorMessage.js